<template>
  <div class="style-jiuhong">
    <header-box @getResult="getResult"></header-box>
    <div class="main">
      <div class="menu">
        <ul
          class="common-width-box flex"
          style="height: 50px; color: #fff; font-size: 16px"
        >
          <li
            class="line-height-50"
            v-for="(item, index) in categoryList"
            :class="sort === item.id ? 'active-class' : ''"
            :key="index"
            @click="tabClick(item)"
          >
            <div class="border-right">{{ item.name }}</div>
          </li>
        </ul>
      </div>
      <div class="common-width-box">
        <router-view v-if="selectObj"></router-view>
      </div>
    </div>
    <foot-box></foot-box>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
import headerBox from "../components/HeaderBox";
import footBox from "../components/FootBox";

export default {
  components: {
    headerBox,
    footBox,
  },
  data() {
    return {
      selectObj: null,
      keyword: "",
      sort: "sy",
      categoryList: [{ id: "sy", name: "首页" }],
      judgeList: ["ss", "sy", "zzfg"],
    };
  },
  provide() {
    return {
      selectObj: () => this.selectObj,
    };
  },
  watch: {
    $route: {
      handler(val) {
        if (!val) return;
        if (!this.$route.query.nochange) {
          this.sort = this.$route.params.id || "sy";
        } else if (localStorage.getItem('sort')) {
          this.sort = localStorage.getItem('sort')
        }
        this.selectObj = this.categoryList.find(
          (item) => item.id === this.sort
        );
        if (this.sort === "xwtz") {
          this.selectObj = {
            id: 'xwtz',
            name: '新闻通知'
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    tabClick(item) {
      if (item.hyperlink) {
        if (item.linkUrl) {
          window.open(item.linkUrl);
        }
      } else {
        localStorage.setItem('sort', item.id)
        const isIndex = item.id === "sy";
        if (isIndex) {
          this.$router.push({
            path: '/index'
          })
        } else {
          this.$router.push({
            path: '/list/' + item.id
          })
        }
      }
    },
    getResult(params) {
      this.keyword = params;
      this.sort = "ss";
    },
    getTitleList() {
      this.$api.index.getCatalog({ root: true }).then((res) => {
        if (res.code === 200) {
          res.data = res.data.filter(category => {
            if (category.name === '新闻通知') {
              this.newsNotice = category;
            }
            return category.name !== '新闻通知';
          });
          this.categoryList = this.categoryList.concat(res.data);
          localStorage.setItem('categoryList', this.categoryList)
          this.selectObj = this.categoryList.find(
            (item) => item.id === this.sort
          );
          if (this.newsNotice?.id === this.sort) {
            this.selectObj = this.newsNotice;
          }
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getTitleList();
  },
};
</script>

<style scoped lang='less'>
.line-height-50 {
  width: 116.1818px;
  text-align: center;
  cursor: pointer;
  padding: 17px 0;
}
// ul li .border-right{
//     border-right: 1px solid #fff;
// }
// ul li:last-child .border-right{
//     border-right: none;
// }
.active-class {
  background: #c81520;
}
.active-class .border-right {
  border: none;
}
.date-class {
  width: 86px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #fff;
  margin-right: 10px;
  text-align: center;
}
.intro-new {
  overflow: hidden;
  font-size: 14px;
  line-height: 24px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
